import { memo, forwardRef, PropsWithChildren, SVGProps, MutableRefObject } from 'react';
import { chakra, PropsOf } from '@chakra-ui/react';

const Circle = memo(function CircleInternal({
   x,
   y,
   r,
   ...props
}: {
   x: number;
   y: number;
   r: number;
} & SVGProps<SVGCircleElement>) {
   return <circle cx={x} cy={y} r={r} {...props} />;
});

// Forwarded for tippy:
// https://github.com/atomiks/tippy.js-react#component-children
const Group = memo(
   // @ts-expect-error TS(2345) FIXME: Argument of type '(props: SVGProps<SVGGElement>, r... Remove this comment to see the full error message
   forwardRef((props: SVGProps<SVGGElement>, ref: MutableRefObject<SVGGElement>) => (
      <g {...props} ref={ref} />
   ))
);

const Text = memo(function TextInternal(props: PropsWithChildren<SVGProps<SVGTextElement>>) {
   return <text {...props}>{props.children}</text>;
});

export const ChakraSVGCircle = chakra(Circle);
export const ChakraSVGGroup = chakra(Group);
export const ChakraSVGText = chakra(Text);
export const ChakraSVG = chakra('svg');

export type ChakraSVGCircleProps = PropsOf<typeof ChakraSVGCircle>;
export type ChakraSVGGroupProps = PropsOf<typeof ChakraSVGGroup>;
export type ChakraSVGTextProps = PropsOf<typeof ChakraSVGText>;
export type ChakraSVGProps = PropsOf<typeof ChakraSVG>;
